import { Fragment, useContext, useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import { FirebaseUser, User } from "../../store/Store";
import NotificationIcon from "../../assets/images/NotificationIcon.svg";
import { updateNotifications } from "../../helpers/FirebaseFunctions";
import Close from "../../assets/images/Close.svg";
import moment from "moment";
import { Link } from "react-router-dom";
import Tabs from "../../components/Tabs/Tabs";
import { INotification } from "../../helpers/Interfaces";

import "./Notifications.scss";

function NotificationsUI() {

  const [selectedTab, setSelectedTab] = useState(0);
  const [newNotifications, setNewNotifications] = useState([] as INotification[]);
  const [readNotifications, setReadNotifications] = useState([] as INotification[]);

  const [user] = useContext(User);
  const [firebaseUser] = useContext(FirebaseUser);

  useEffect(() => {
    let newNotifications = firebaseUser?.notifications?.filter((notification: INotification) => {
      return !notification.read
    });

    let readNotifications = firebaseUser?.notifications?.filter((notification: INotification) => {
      return notification.read
    });

    setNewNotifications(newNotifications);
    setReadNotifications(readNotifications);
  }, [firebaseUser])

  async function markAsRead(id: number) {

    let notification: INotification = firebaseUser?.notifications.find((notification: INotification) => {
      return notification?.id === id;
    });

    Object.assign(notification, { read: true });

    let newNotifications: INotification[] = firebaseUser?.notifications.filter((notification: INotification) => {
      return notification?.id !== id;
    });

    newNotifications.push(notification);
    await updateNotifications(user?.notificationId, newNotifications);
  }

  async function removeNotification(id: number) {
    let newNotifications: INotification[] = firebaseUser?.notifications.filter((notification: INotification) => {
      return notification?.id !== id;
    });

    await updateNotifications(user?.notificationId, newNotifications);
  }

  async function clearNotifications() {

    let newNotifications: INotification[] = [];

    if (selectedTab === 0) {
      newNotifications = firebaseUser?.notifications.filter((notification: INotification) => {
        return notification?.read;
      });
    } else if (selectedTab === 1) {
      newNotifications = firebaseUser?.notifications.filter((notification: INotification) => {
        return !notification?.read;
      });
    }

    await updateNotifications(user?.notificationId, newNotifications);
  }

  function renderNotifications(notifications: INotification[]) {
    return (notifications?.map((notification: INotification, index: number) => {
      return (<div key={index} className="notification-content">
        <div className="data">
          <img className="profile-img" src={NotificationIcon} alt="Information" />
          <span className="message">{notification?.text}</span>
        </div>
        <div className="other-data">
          <div className="status-title">{moment.utc(notification?.createdDate?.seconds * 1000).fromNow()}</div>
          <Link to={`/dashboard/reports/${notification?.documentId}`} className="view-report">View Report</Link>
          <span className="close-notification">
            <img className='close' src={Close} alt="Close"
              onClick={() => { selectedTab === 0 ? markAsRead(notification?.id) : removeNotification(notification?.id) }} />
          </span>
        </div>
      </div>);
    }))
  }

  return (
    <Layout selectedIndex={6}>
      <div className="notification-container animated animatedFadeInUp fadeInUp">
        <div className="notification-title">Notifications</div>
        <div className="notification-sub-title">
          {newNotifications?.length === 1
            ? "You have " + newNotifications?.length + " alert"
            : "You have " + newNotifications?.length + " alerts"
          }
        </div>
        <div className="notification-body animated animatedFadeInUp fadeInUp">
          <div className="notification-header animated animatedFadeInUp fadeInUp">
            <Tabs titles={['New', 'History']} selectedIndex={selectedTab} onClick={setSelectedTab} />
            <button onClick={() => { clearNotifications() }}>Clear All</button>
          </div>
          <div className="content animated animatedFadeInUp fadeInUp">
            {selectedTab == 0
              ? (renderNotifications(newNotifications))
              : (<Fragment />)
            }
            {selectedTab == 1
              ? (renderNotifications(readNotifications))
              : (<Fragment />)
            }
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default NotificationsUI;
